import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Store } from '@df/catalog/store/store';
import { CheckoutStorePickupComponentDef } from '@df/checkout/checkout-store-pickup.component.def';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import compact from 'lodash-es/compact';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { RadioComponent } from '../ui/form/radio';
@Component({
    selector: 'checkout-store-pickup',
    templateUrl: './checkout-store-pickup.html',
    standalone: true,
    imports: [TranslationModule, FormsModule, RadioGroupDirective, RadioComponent, InputWrapComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutStorePickupComponent extends CheckoutStorePickupComponentDef {
    protected clicked = false;

    getStoreAddress(store: Store): string {
        return store.data ? compact([store.data.address, store.data.city, store.data.postcode]).join(', ') : '';
    }
    get saving(): boolean {
        return this.clicked && this.saveStatus.busy;
    }
    onClick(): void {
        this.clicked = true;
    }
}
